module.exports = __webpack_public_path__ + "img/Group4_26.d8983ab9.jpg";